import { ApiResourceFactory } from '../api.resource.factory'
import { GridModel, GridRequestModel, EntityModel, DeviceHierarchyModel, IssueModel, SaveFileModel, FileModel, LocationEquipmentModel, FormValuesModel, ResponseListModel, ResponseDeleteModel } from '../api.models'
import { CommonHelper } from '../../../helpers/common-helper'

export interface IIssuesService {
    getIssues(req: GridRequestModel, state?: any): ng.IPromise<GridModel>
    createIssue(req): ng.IPromise<IssueModel>
    createMassIssue(req): ng.IPromise<any>
    getIssue(id, state?: any): ng.IPromise<IssueModel>
    getIssueToEdit(id, state?: any): ng.IPromise<EntityModel>
    deleteIssue(id): ng.IPromise<ResponseDeleteModel>
    saveIssue(req): ng.IPromise<IssueModel>
    checkIfAttachmentExists(id, attachmentId): ng.IPromise<string>
    getAttachments(id, state?: any): ng.IPromise<ResponseListModel<FileModel>>
    getEquipment(id, state?: any): ng.IPromise<ResponseListModel<LocationEquipmentModel>>
    saveAttachment(attachment: FileModel): ng.IPromise<SaveFileModel>
    deleteAttachments(model: FormValuesModel): ng.IPromise<ResponseListModel<number>>
}

export class IssuesService implements IIssuesService {
    constructor(private apiResource: ApiResourceFactory) {

    }

    getIssues(req: GridRequestModel, state: any = {}) {
        var get = this.apiResource.issues.query
        state.request = get(req)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getIssue(id, state: any = {}) {
        var get = this.apiResource.issues.get
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state, false, rej.data.Message))
    }

    getIssueToEdit(id, state: any = {}) {
        var getIssueToEdit: ng.resource.IResourceMethod<ng.resource.IResource<EntityModel>> = this.apiResource.issues['getIssueToEdit']
        state.request = getIssueToEdit({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    saveIssue(req): ng.IPromise<IssueModel> {
        return this.apiResource.issues.save(req).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    createIssue(req): ng.IPromise<IssueModel> {
        return this.apiResource.issues.save(req).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    createMassIssue(req) {
        return this.apiResource.issues.save(req).$promise.then(result => {
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, 0))
    }

    deleteIssue(id): ng.IPromise<ResponseDeleteModel> {
        return this.apiResource.issues.delete({ id: id }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    checkIfAttachmentExists(id, attachmentId): ng.IPromise<string> {
        var checkIfExists: ng.resource.IResourceMethod<ng.resource.IResource<string>> = this.apiResource.issues['checkIfAttachmentExists']
        return checkIfExists({ id: id, attachmentId: attachmentId }).$promise.then(r => {
                var result = ""
                var rJSON = (<any>r).toJSON()
                for (var i in rJSON) {
                    result += rJSON[i]
                }
                return result
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getAttachments(id, state: any = {}) {
        var getAttachments: ng.resource.IResourceMethod<ng.resource.IResource<ResponseListModel<FileModel>>> = this.apiResource.issues['getAttachments']
        state.request = getAttachments({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getEquipment(id, state: any = {}) {
        var getEquipment: ng.resource.IResourceMethod<ng.resource.IResource<ResponseListModel<LocationEquipmentModel>>> = this.apiResource.issues['getEquipment']
        state.request = getEquipment({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    saveAttachment(attachment: FileModel): ng.IPromise<SaveFileModel> {
        var saveAttachment: ng.resource.IResourceMethod<ng.resource.IResource<SaveFileModel>> = this.apiResource.issues['saveAttachment']
        return saveAttachment(attachment).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    deleteAttachments(model: FormValuesModel): ng.IPromise<ResponseListModel<number>> {
        var deleteAttachment: ng.resource.IResourceMethod<ng.resource.IResource<ResponseListModel<number>>> = this.apiResource.issues['deleteAttachment']
        return deleteAttachment(model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }
}
